import {accountRecurringOrderItemSettings, AccountRecurringOrderItemSettings} from '../../../bps/components/accountRecurringOrderItem/accountRecurringOrderItemSettings';

accountRecurringOrderItemSettings.buttonClass.edit = 'button--secondary';
accountRecurringOrderItemSettings.buttonClass.skip = 'button--link';
accountRecurringOrderItemSettings.buttonClass.link = 'button--link';
accountRecurringOrderItemSettings.buttonClass.items = 'button--primary';

export {accountRecurringOrderItemSettings, AccountRecurringOrderItemSettings};
